import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {Tooltip, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {setZoomLevel} from '../actions/map.js';
import Button from './button.jsx';

const Wrapper = styled('div')(({theme}) => ({
  width: 40,
  marginTop: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

const buttonOptions = theme => ({
  minWidth: 'initial',
  paddingInline: 8,
  ...theme.applyStyles('dark', {
    ':hover': {
      backgroundColor: (theme.vars ?? theme).palette.background.paper,
      backgroundImage:
        'linear-gradient(rgba(255 255 255 / 0.1), rgba(255 255 255 / 0.1))',
    },
  }),
});

const ZoomInButton = styled(Button)(({theme}) => ({
  ...buttonOptions(theme),
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}));

const ZoomOutButton = styled(Button)(({theme}) => ({
  ...buttonOptions(theme),
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}));

const ZoomButtons = ({zoom, setZoomLevel}) => {
  const handleZoomInClick = () => setZoomLevel(Math.round(zoom) + 1);

  const handleZoomOutClick = () => setZoomLevel(Math.round(zoom) - 1);

  const disabled = zoom === undefined;

  return (
    <Wrapper data-qe="zoom-tool">
      <Tooltip title="Zoom in" placement="left">
        <span>
          <ZoomInButton
            data-qe="zoom-in-button"
            disabled={disabled}
            onClick={handleZoomInClick}
          >
            <AddIcon />
          </ZoomInButton>
        </span>
      </Tooltip>
      <Tooltip title="Zoom out" placement="left">
        <span>
          <ZoomOutButton
            data-qe="zoom-out-button"
            disabled={disabled}
            onClick={handleZoomOutClick}
          >
            <RemoveIcon />
          </ZoomOutButton>
        </span>
      </Tooltip>
    </Wrapper>
  );
};

ZoomButtons.propTypes = {
  setZoomLevel: PropTypes.func.isRequired,
  zoom: PropTypes.number,
};

const mapDispatchToProps = {setZoomLevel};

const mapStateToProps = state => ({
  zoom: state.map.zoom,
});

export default connect(mapStateToProps, mapDispatchToProps)(ZoomButtons);
